import LegalLayout from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "Acceptance of Terms",
    body: [
      "By accessing this website, selecting a service, or completing a payment, you agree to be bound by these Terms of Service. If you do not agree, please do not use our services or make a payment.",
    ],
  },
  {
    heading: "About Radio App Consultancy",
    body: [
      "Radio App Consultancy is an independent, third-party consultancy. We provide expert consultation and deliver radio setup guidance, websites, mobile apps, custom software and genuine antivirus for a one-time charge.",
      "We do not offer any subscription and never bill you on a recurring basis. We are not affiliated with, endorsed by, or sponsored by any brand. All product names, logos, and trademarks are the property of their respective owners.",
    ],
  },
  {
    heading: "Services",
    body: [
      "We provide (a) software consultation, and (b) one-time project setup and development covering web, mobile and custom software. The specific scope depends on the service you select at checkout.",
      "All charges are one-time for the service selected — there is no subscription and no auto-renewal.",
      "15-Day Guarantee: If you experience any issue after your delivery is completed, report it within 15 days and we will fix it free of charge.",
    ],
  },
  {
    heading: "Payments & Billing",
    body: [
      "All payments are processed securely through Razorpay or PayPal. We do not store your full card details on our servers.",
      "Prices are shown in US Dollars (USD). The amount you enter and authorize at checkout is the one-time amount that will be charged. We do not offer subscriptions and will not charge you again unless you place a new order.",
      "By checking the consent box and clicking Pay, you authorize this one-time service charge for the service or amount you selected.",
    ],
  },
  {
    heading: "Refunds",
    body: [
      "Refunds are governed by our Refund Policy. Please review it before completing your payment.",
    ],
  },
  {
    heading: "Your Responsibilities",
    body: [
      "You agree to provide accurate information (name, email, phone, and any project details) needed to deliver the service.",
      "You are responsible for providing the requirements, access and materials needed for us to complete the work.",
    ],
  },
  {
    heading: "Chargebacks & Disputes",
    body: [
      "If you have any concern about a charge, please contact us first at akarjagdev@gmail.com before initiating a bank chargeback, and we will work to resolve it quickly.",
      "For authorized payments where services have been rendered as described, we reserve the right to submit evidence of your consent and service delivery to dispute any unwarranted chargeback.",
    ],
  },
  {
    heading: "Intellectual Property",
    body: [
      "Upon full payment for a completed project, deliverables produced specifically for you are transferred to you, unless otherwise agreed in writing. We may retain reusable components, libraries and know-how used to build them.",
    ],
  },
  {
    heading: "Limitation of Liability",
    body: [
      "Services are provided on an 'as is' basis. To the maximum extent permitted by law, Radio App Consultancy shall not be liable for any indirect or consequential damages arising from the use of our services.",
    ],
  },
  {
    heading: "Changes to These Terms",
    body: [
      "We may update these Terms from time to time. Continued use of our services after changes are posted constitutes acceptance of the updated Terms.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalLayout
      title="Terms of Service"
      updated="June 2026"
      intro="These Terms of Service govern your use of Radio App Consultancy and any payment you make through this website."
      sections={SECTIONS}
    />
  );
}
